import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import FaqSection from './components/FaqSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AppSection />
        <RankingSection />
        <TopicsSection />
        <ContactSection />
        <CommentsSection />
        <AboutSection />
        <MediaSection />
        <CardsSection />
        <CarouselSection />
        <FaqSection />
        <IndexSection />
        <UpdatesSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}